import React, { useState} from 'react';
import { useForm } from 'react-hook-form';

import api from '../../api';


// Every signup lands on the same Kit list whatever the copy says -- see the TODO
// in server/api/controllers/waitlist.py about splitting lists per initiative.
const Waitlist = ({
  title = 'Join the Waitlist!',
  blurb = "There's a lot going on at Code Scribes and the best way to keep up with it all is joining the waitlist or following us on social media.",
  successMessage = (email) => `Congratulations ${email} has been added to the waitlist!`
}) => {
  const { register, handleSubmit, reset } = useForm({
    defaultValues: { first: '', last: '', email: '' }
  });
  const [status, setStatus] = useState({ success: undefined, msg: undefined });

  const addToWaitlist = async ({ firstName, lastName, email }) => {
    try {
      await api.waitlist.addSubscriber({ email, firstName, lastName});
    } catch (err) {
      console.log(err);
      setStatus({ success: false, msg: err.response.data.error })
      return
    }

    setStatus({ success: true, msg: successMessage(email) })
    reset(); // Reset the form
  };

  return (
    <div className='rounded-lg border border-neutral-800 bg-neutral-900 p-6 shadow-sm w-full'>
      <h2 className='font-heading text-2xl text-neutral-50 mb-2'>{title}</h2>
      <p className='font-body text-sm text-neutral-400 mb-6'>{blurb}</p>
      <form onSubmit={handleSubmit(addToWaitlist)} className='flex flex-col gap-3'>
        <input
          className='h-10 w-full rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-2 font-body text-sm text-neutral-50 placeholder:text-neutral-500 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'
          placeholder='First Name'
          {...register('firstName')}
        />
        <input
          className='h-10 w-full rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-2 font-body text-sm text-neutral-50 placeholder:text-neutral-500 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'
          placeholder='Last Name'
          {...register('lastName')}
          />
        <div className='flex flex-row gap-3'>
          <input
            className='flex-1 h-10 rounded-lg border border-neutral-700 bg-neutral-900 px-3 py-2 font-body text-sm text-neutral-50 placeholder:text-neutral-500 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'
            placeholder='Email'
            {...register('email', { required: 'required' })}
          />
          <input
            type='submit'
            value='Subscribe'
            className='inline-flex items-center justify-center rounded-lg px-5 py-2.5 bg-primary text-sm font-body text-white shadow-sm transition-colors duration-150 hover:bg-primary-light cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'
          />
        </div>
        { status.success ? (
          <div className="rounded-lg border border-success/20 bg-success-dark p-3 mt-2" role="alert">
            <span className="font-body text-sm text-success">{status.msg}</span>
          </div>
        ) : null }
        { status.success === false ? (
          <div className="rounded-lg border border-error/20 bg-error-dark p-3 mt-2" role="alert">
            <span className="font-body text-sm text-error">{status.msg}</span>
          </div>
        ) : null }
      </form>
    </div>
  );
};

export default Waitlist;
